// The Dashboard stays mounted behind the other tabs and throttles its reloads
// (30 s for widgets/progress, calendar only on first load). A change made on
// another screen that alters what it shows — cancelling the FREE trial — would
// otherwise be invisible when the member lands back on it. Whoever makes such a
// change marks the data stale; the Dashboard consumes the mark on its next entry
// and reloads everything, past the throttle.
let homeDataStale = false;

export const markHomeDataStale = () => {
  homeDataStale = true;
};

export const consumeHomeDataStale = () => {
  const wasStale = homeDataStale;
  homeDataStale = false;
  return wasStale;
};
